import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Card, Form, DatePicker, Select, Spin, message } from 'antd'
import { getResourceForImport } from '../../appRedux/actions/Organisation'
import { faviconDynamicFunction } from '../../util/methods'
import axios from 'util/Api'
import moment from 'moment'

const { Option } = Select
const { RangePicker } = DatePicker

const BulkFuelProcess = ({
    match,
    loading,
    authUser,
    data,
    getResourceForImport,
    form
}) => {
    const { getFieldDecorator } = form
    const [processing, setProcessing] = useState(false)

    useEffect(() => {
        getResourceForImport()
    }, [])

    const onFinish = async (values) => {
        try {
            setProcessing(true)

            // Convert date range to milliseconds
            const fromMs = moment(values.period[0]).startOf('day').valueOf()
            const toMs = moment(values.period[1]).endOf('day').valueOf()

            // const payload = {
            //     organisation: values.organisation,
            //     period: {
            //         from: fromMs,
            //         to: toMs
            //     }
            // }

            // console.log('Bulk Fuel Process payload:', payload)

            // Make API call
            const response = await axios.get(`/daily-fuel-data/process-all-in-period/${values.organisation}/${fromMs}/${toMs}`)

            message.success('Bulk fuel process completed successfully!')
            // console.log('API Response:', response.data)

            // Download the JSON response data
            if (response.data) {
                const jsonString = JSON.stringify(response.data, null, 2)
                const blob = new Blob([jsonString], { type: 'application/json' })
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url

                // Generate filename with timestamp
                const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss')
                const filename = `bulk-fuel-process-result_${timestamp}.json`

                link.download = filename
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
            }

        } catch (error) {
            console.error('Error processing bulk fuel:', error)
            message.error('Failed to process bulk fuel data')
        } finally {
            setProcessing(false)
        }
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Form validation failed:', errorInfo)
        message.error('Please check the form for errors')
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        form.validateFields((err, values) => {
            if (!err) {
                onFinish(values)
            } else {
                onFinishFailed({ errorFields: err, values })
            }
        })
    }

    faviconDynamicFunction(authUser)

    return (
        <Spin spinning={loading || processing}>
            <Card className={`gx-card-metrics`}>
                <span>
                    <h2>Bulk Fuel Process</h2>
                    <p>Process fuel data for a specific organisation and time period</p>
                </span>

                <div style={{ marginTop: '30px', marginLeft: '2%', width: '50%' }}>
                    <Form
                        layout="vertical"
                        onSubmit={handleSubmit}
                    >
                        <Form.Item label="Select Organisation">
                            {getFieldDecorator("organisation", {
                                rules: [{ required: true, message: 'Organisation is required!' }],
                            })(
                                <Select
                                    mode='single'
                                    showSearch
                                    allowClear
                                    placeholder={'Select Organisation'}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {data && data.length && data.map(org =>
                                        <Option key={org._id} value={org._id}>{org.name}</Option>
                                    )}
                                </Select>
                            )}
                        </Form.Item>

                        <Form.Item label="Select Period">
                            {getFieldDecorator("period", {
                                rules: [{ required: true, message: 'Period is required!' }],
                            })(
                                <RangePicker
                                    // showTime
                                    format="DD/MM/YYYY"
                                    placeholder={['From Date', 'To Date']}
                                    style={{ width: '100%' }}
                                />
                            )}
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                className="gx-mb-0"
                                htmlType="submit"
                                loading={processing}
                                size="large"
                                disabled={processing}
                            >
                                {processing ? 'Processing...' : 'Process Fuel Data'}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Card>
        </Spin>
    )
}

const mapStateToProps = ({ organisation, commonData }) => {
    return {
        loading: commonData.loading,
        data: organisation.resources,
        authUser: commonData.authUser
    }
}

export default connect(mapStateToProps, {
    getResourceForImport
})(Form.create()(BulkFuelProcess))
